// extracted by mini-css-extract-plugin
module.exports = {"container":"az_Uad","label":"az_Vad","priceAndBadge":"az_Wad","productName":"az_Xad","link":"az_Yad","disabled":"az_Zad"};